import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ServiceCenter from '@/components/serviceView/ServiceCenter.vue'
// import WOW from 'wowjs'

export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ServiceCenter))
}
}

})